class textSlide {
    constructor(slide) {
        this.slidecontainer = slide;
        this.slides = slide.data('slides-text').split(',');
        this.colors = slide.data('slides-color').split(',');
        this.insertSlides();
        this.fadeText();
    }

    insertSlides() {
        let that = this;
        let slideinner = '';
        let currentclass;

        $.each(that.slides, function (index, value) {
            if (index == 0) {
                currentclass = 'current';
            } else {
                currentclass = '';
            }

            slideinner += '<div class="' + currentclass + ' slide-text__inner ' + that.colors[index] + '">' + value + '<br>in</div>';
        });
        that.slidecontainer.html(slideinner);
    }

    fadeText() {
        let that = this;
        setInterval(function () {
                let c = that.slidecontainer;
                let curSlide = $('.slide-text__inner.current');
                let nxtSlide = curSlide.next();
                if (nxtSlide.length == 0) {
                    nxtSlide = $('.slide-text__inner').first();
                }

                curSlide.removeClass('current');
                nxtSlide.addClass('current');
            }
            , 5500
        );
    }
}